import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import TenantAPI from "../../api/TenantAPI";
import { BulkEmailOperations } from "../../../components/Drawers/EmailBuilderDrawer/EmailBuilderTypes";
import { DefaultFields } from "../../../types/GlobalInterfaces";

const emptyArray: [] = [];

type SavedEmailActions = BulkEmailOperations & DefaultFields;

const useBulkEmails = () => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const tenantID = useAtomValue(tenantIDAtom);

  const emailActions = useQuery({
    queryKey: ["bulkEmails", tenantID],
    queryFn: () =>
      TenantAPI.getBulkEmails().then((data) => {
        const emailActions: SavedEmailActions[] = data.data.data.emailActions;
        return emailActions;
      }),
    enabled: queriesEnabled,
    staleTime: Infinity,
  });

  const data: {
    emailActions: SavedEmailActions[];
    emailActionsLoading: boolean;
  } = {
    emailActions: (emailActions.data as SavedEmailActions[]) || emptyArray,
    emailActionsLoading: emailActions.isLoading,
  };

  return data;
};

export default useBulkEmails;
